// ============================================================
// Hirafi — Module devis standalone : types
// ============================================================

import type { QuoteLineItem } from "@/hooks/useQuotes";

// Ré-export pour usage interne du module
export type { QuoteLineItem };

export interface ArtisanInfo {
  name: string;
  email: string;
  phone: string;
  address?: string;
  activity?: string;
}

export interface ClientInfo {
  name: string;
  email: string;
  phone?: string;
  address?: string;
}

export type StandaloneDevisStatus =
  | "draft"
  | "sent"
  | "viewed"
  | "accepted"
  | "rejected"
  | "cancelled"
  | "expired";

/** Représentation d'un devis standalone (mode invité ou connecté, sans conversation) */
export interface StandaloneDevis {
  id: string;
  artisan: ArtisanInfo;
  client: ClientInfo;
  title: string;
  description: string;
  lineItems: QuoteLineItem[];
  totalAmount: number;
  currency: string;
  validUntil: string;
  estimatedDelay?: string;
  notes?: string;
  status: StandaloneDevisStatus;
  publicToken?: string;
  createdAt: string;
  updatedAt: string;
}

/** Données du formulaire de création d'un devis standalone */
export interface StandaloneDevisFormData {
  artisan: ArtisanInfo;
  client: ClientInfo;
  title: string;
  description: string;
  lineItems: Omit<QuoteLineItem, "id" | "quote_id">[];
  totalAmount: number;   // Montant HT
  vatRate?: number;       // Taux TVA en % (ex: 19), undefined = pas de TVA
  currency: string;
  validUntil: string;
  estimatedDelay?: string;
  notes?: string;
}

export const DELAY_OPTIONS = [
  { value: "within_24h",   label: "Sous 24h" },
  { value: "within_3_days", label: "Sous 3 jours" },
  { value: "within_1_week", label: "Sous 1 semaine" },
  { value: "flexible",     label: "À convenir" },
] as const;

export type DelayValue = (typeof DELAY_OPTIONS)[number]["value"];
